export const typesPayment = {
  PIX: 11,
  BOLETO: 7,
  PIX_PARCELADO: 15,
}
